import api, { unwrap } from './client';

export async function listWaitlist(params = {}) {
  return unwrap(await api.get('/admin/waitlist', { params }));
}

// CSV export — returns a Blob (raw file, not the JSON envelope).
export async function exportWaitlistCsv(params = {}) {
  const res = await api.get('/admin/waitlist/export.csv', {
    params,
    responseType: 'blob',
  });
  return res.data;
}

export async function deleteWaitlistEntry(id) {
  return unwrap(await api.delete(`/admin/waitlist/${id}`));
}
